import { render, staticRenderFns } from "./handle-task-detail.vue?vue&type=template&id=6cffed46&scoped=true&"
import script from "./handle-task-detail.vue?vue&type=script&lang=js&"
export * from "./handle-task-detail.vue?vue&type=script&lang=js&"
import style0 from "./handle-task-detail.vue?vue&type=style&index=0&id=6cffed46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cffed46",
  null
  
)

export default component.exports